module.exports = {
  "branding.url": process.env.REACT_APP_BRANDING_URL,
  "elvis.url": process.env.REACT_APP_ELVIS_URL,
  "googleAnalytics.id": process.env.REACT_APP_ANALYTICS_ID,
  "okta.url": process.env.REACT_APP_OKTA_URL,
  "okta.clientId": process.env.REACT_APP_OKTA_CLIENT_ID,
  "cognito.url": process.env.REACT_APP_COGNITO_URL,
  "cognito.clientId": process.env.REACT_APP_COGNITO_CLIENT_ID
}
